/** Re-export for legacy paths; prefer `font-map` where tree-shaking matters. */
export { FontMap } from "./font-map";
